module.exports = __webpack_public_path__ + "img/SSI_Logo.7df9c195.png";